// extracted by mini-css-extract-plugin
module.exports = {"title":"title__3ATXq","image":"image__VpqcW","content":"content__2UjY5","contacts":"contacts__3uFCZ","contact":"contact__2UZKF","map":"map__3O3Fg","margin":"margin__15vQJ"};